<template>
  <div class="main">
    <div class="detail">
      <ListTable @getdetails="getdetails" ref="table"></ListTable>
    </div>
    <div>
      <Preview
        :catesingle="catesingle"
        :articleId="articleId"
        :articleVis="articleVis"
        :catid="-1"
        @close="close"
      ></Preview>
    </div>
  </div>
</template>

<script>
import ListTable from './ListTable';
import Preview from './preview';
export default {
  components: { ListTable, Preview },
  data() {
    return {
      catid: 0,
      catesingle: [],
      articleId: 0,
      articleVis: false
    };
  },
  created() {},
  mounted() {},
  methods: {
    getdetails(id) {
      this.articleId = id;
      this.articleVis = true;
    },
    close() {
      this.articleVis = false;
    }
  }
};
</script>

<style scoped>
.wrap {
  position: relative;
}
.caret {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 6px dashed;
  border-right: 6px dashed;
  border-bottom: 6px solid transparent;
  border-left: 6px solid transparent;
}
.primary {
  border-top-color: #1890ff;
  border-right-color: #1890ff;
}
.gray {
  border-top-color: #d9d9d9;
  border-right-color: #d9d9d9;
}
.main {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  /*padding-top:10px*/
}

.catelists {
  max-height: 300px;
  overflow: hidden;
  overflow-y: auto;
}

.cate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 10px;
  text-align: left;
  /*height: 38px;*/
  line-height: 38px;
}
.cate:hover {
  background: #eeeeee;
}

.dropdown-key {
  max-height: 600px;
  overflow: hidden;
  overflow-y: auto;
  width: 800px;
}

code {
  margin: 0 1px;
  background: #f2f4f5;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 0.9em;
  color: #7e7e7e;
  border: 1px solid #eee;
}
</style>
